import { match as notApi } from "../../../src/params/notApi.ts";

export const matchers = { notApi };